import { PlaySquareOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React from "react";

interface IProps {
    mediaStatus?: string;
    margin?: number;
    minimal?: boolean;
}

const renderNoVideo = (margin: number, minimal: boolean) => {
    return (
        <span style={{ marginLeft: margin ? margin + "px" : "20px" }}>
            <Tooltip title="There is no video for this activity.">
                {minimal ? (
                    <div className="activity-action-item">
                        <PlaySquareOutlined
                            style={{
                                opacity: 0.3,
                            }}
                        />
                        <span>No video</span>
                    </div>
                ) : (
                    <Tag icon={<PlaySquareOutlined />} className="activity-video-tag no-video">
                        No video
                    </Tag>
                )}
            </Tooltip>
        </span>
    );
};

const renderPending = (margin: number, minimal: boolean) => {
    return (
        <span style={{ marginLeft: margin ? margin + "px" : "20px" }}>
            <Tooltip title="Currently awaiting upload. Check back soon.">
                {minimal ? (
                    <div className="activity-action-item activity-video-tag pending">
                        <PlaySquareOutlined />
                        <span>Pending</span>
                    </div>
                ) : (
                    <Tag icon={<PlaySquareOutlined />} className="activity-video-tag pending">
                        Pending
                    </Tag>
                )}
            </Tooltip>
        </span>
    );
};

const renderCreated = (margin: number, minimal: boolean) => {
    return (
        <span style={{ marginLeft: margin ? margin + "px" : "20px" }}>
            <Tooltip title="Awaiting conversion. Check back soon.">
                {minimal ? (
                    <div className="activity-action-item activity-video-tag created">
                        <PlaySquareOutlined />
                        <span>Processing</span>
                    </div>
                ) : (
                    <Tag icon={<PlaySquareOutlined />} className="activity-video-tag created">
                        Processing
                    </Tag>
                )}
            </Tooltip>
        </span>
    );
};

const renderError = (margin: number, minimal: boolean) => {
    return (
        <span style={{ marginLeft: margin ? margin + "px" : "20px" }}>
            <Tooltip title="Sorry, an error occurred while converting this video.">
                {minimal ? (
                    <div className="activity-action-item activity-video-tag error">
                        <PlaySquareOutlined />
                        <span>Error</span>
                    </div>
                ) : (
                    <Tag icon={<PlaySquareOutlined />} className="activity-video-tag error">
                        Error
                    </Tag>
                )}
            </Tooltip>
        </span>
    );
};

const VideoTag: React.FC<IProps> = ({ mediaStatus, margin, minimal }: IProps) => {
    if (mediaStatus == null) return renderNoVideo(margin, minimal);
    switch (mediaStatus) {
        case "complete":
            return null;
        case "created":
        case "processing":
            return renderCreated(margin, minimal);
        case "pending":
            return renderPending(margin, minimal);
        case "error":
            return renderError(margin, minimal);
        default:
            return null;
    }
};
export default VideoTag;
